import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/pp-profile-icon.svg'
import _imports_1 from '../assets/svg/sm-google.svg'
import _imports_2 from '../assets/svg/sm-facebook.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-01fe05ba")

_pushScopeId("data-v-01fe05ba")
const _hoisted_1 = {
  key: 0,
  src: _imports_0
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Email Address")
const _hoisted_3 = { class: "input-container" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Full Name")
const _hoisted_5 = { class: "input-container" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Phone Number")
const _hoisted_7 = { class: "input-container" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Date of birth")
const _hoisted_9 = { class: "input-container" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Change Password")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Logout")
const _hoisted_13 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "Connect With Google", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("span", null, "Connect With Facebook", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_grid = _resolveComponent("ion-grid")!

  return (_ctx.user)
    ? (_openBlock(), _createBlock(_component_ion_grid, { key: 0 }, {
        default: _withId(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center ion-justify-content-center padding-area" }, {
            default: _withId(() => [
              _createVNode(_component_ion_col, { class: "ion-align-items-center ion-justify-content-center profile-image" }, {
                default: _withId(() => [
                  (!_ctx.user.profile_image)
                    ? (_openBlock(), _createBlock("img", _hoisted_1))
                    : _createCommentVNode("", true),
                  (_ctx.user.profile_image)
                    ? (_openBlock(), _createBlock("img", {
                        key: 1,
                        src: _ctx.user.profile_image
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "ion-align-items-center ion-justify-content-center padding-bottom" }, {
            default: _withId(() => [
              _createVNode(_component_ion_col, {
                sizeXl: "3",
                sizeLg: "6",
                sizeMd: "8",
                sizeSm: "12"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_label, { color: "secondary" }, {
                    default: _withId(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode("div", _hoisted_3, [
                    _createVNode(_component_ion_input, {
                      class: "account-email account-input",
                      type: "email",
                      modelValue: _ctx.user.email,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.user.email = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "ion-align-items-center ion-justify-content-center padding-bottom" }, {
            default: _withId(() => [
              _createVNode(_component_ion_col, {
                sizeXl: "3",
                sizeLg: "6",
                sizeMd: "8",
                sizeSm: "12"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_label, { color: "secondary" }, {
                    default: _withId(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode("div", _hoisted_5, [
                    _createVNode(_component_ion_input, {
                      class: "account-input",
                      type: "text",
                      modelValue: _ctx.user.name,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.user.name = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "ion-align-items-center ion-justify-content-center padding-bottom" }, {
            default: _withId(() => [
              _createVNode(_component_ion_col, {
                sizeXl: "1.5",
                sizeLg: "3",
                sizeMd: "4",
                sizeSm: "6"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_label, { color: "secondary" }, {
                    default: _withId(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode("div", _hoisted_7, [
                    _createVNode(_component_ion_input, {
                      class: "account-input",
                      type: "phone",
                      modelValue: _ctx.user.phone,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.user.phone = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                sizeXl: "1.5",
                sizeLg: "3",
                sizeMd: "4",
                sizeSm: "6"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_label, { color: "secondary" }, {
                    default: _withId(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _createVNode("div", _hoisted_9, [
                    _createVNode(_component_ion_input, {
                      class: "account-input",
                      type: "text",
                      placeholder: "optional",
                      modelValue: _ctx.user.dob,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.user.dob = $event)),
                      onIonFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.calendarFocus($event)))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "ion-align-items-center ion-justify-content-center padding-bottom" }, {
            default: _withId(() => [
              _createVNode(_component_ion_col, {
                sizeXl: "3",
                sizeLg: "3",
                sizeMd: "4",
                sizeSm: "6"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _ctx.updateUser,
                    color: "success",
                    expand: "block",
                    sizeXl: "large"
                  }, {
                    default: _withId(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (Object.keys(_ctx.errors).length > 0)
            ? (_openBlock(), _createBlock(_component_ion_row, {
                key: 0,
                class: "pad-bot"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.errors, (msg, index) => {
                        return (_openBlock(), _createBlock(_component_ion_text, {
                          class: "ion-text-center",
                          color: "danger",
                          key: index
                        }, {
                          default: _withId(() => [
                            _createVNode("p", null, _toDisplayString(msg[0]), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_row, { class: "\n        ion-align-items-center ion-justify-content-center\n        padding-bottom\n        double\n      " }, {
            default: _withId(() => [
              _createVNode(_component_ion_col, {
                class: "ion-text-center",
                sizeXl: "3",
                sizeLg: "4",
                sizeMd: "6",
                sizeSm: "12"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    fill: "clear",
                    class: "password",
                    onClick: _ctx.changePassword
                  }, {
                    default: _withId(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_ion_button, {
                    onClick: _ctx.logout,
                    color: "danger"
                  }, {
                    default: _withId(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "ion-align-items-center ion-justify-content-center" }, {
            default: _withId(() => [
              _createVNode(_component_ion_col, {
                sizeXl: "3",
                sizeLg: "4",
                sizeMd: "6",
                sizeSm: "12"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _ctx.loginGoogle,
                    class: "google social-button",
                    fill: "clear",
                    expand: "block",
                    sizeXl: "large"
                  }, {
                    default: _withId(() => [
                      _hoisted_13,
                      _hoisted_14
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "ion-align-items-center ion-justify-content-center padding-bottom" }, {
            default: _withId(() => [
              _createVNode(_component_ion_col, {
                sizeXl: "3",
                sizeLg: "4",
                sizeMd: "6",
                sizeSm: "12"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _ctx.loginFacebook,
                    class: "facebook social-button",
                    expand: "block",
                    sizeXl: "large"
                  }, {
                    default: _withId(() => [
                      _hoisted_15,
                      _hoisted_16
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
})